import { Grid } from '@mui/material';
import { ICandidate } from 'wisestep-api';
import { WsDataTable } from 'wisestep-base';

interface CandidateProfileDetailsProps {
  candidate: ICandidate;
}

const RecruiterQuestionDetails = ({ candidate }: CandidateProfileDetailsProps) => {
  const columns = [
    {
      Header: 'Question',
      accessor: 'question',
    },
    {
      Header: 'Answer',
      accessor: 'answer',
    },
  ];
  const QA: any = candidate?.questionResponse ?? [];
  return (
    <Grid container mt={2}>
      <WsDataTable columns={columns} data={QA ?? []} selectable={false} />
    </Grid>
  );
};

export default RecruiterQuestionDetails;
